'use strict';
window.uomedia = window.uomedia || {};

(($) => {
  /* FILTER CATEGORY BY POST TYPE */
  const filter = window.uomedia.getQueryVariable('postType');
  const isArchive = $('body.archive.category').length > 0;
  if (isArchive) {
    $('article[data-post-type!="' + filter + '"]').parent().hide();
    $('article[data-post-type="' + filter + '"]').parent().show();
  }
})(jQuery);
